import { Group } from "@mantine/core";
import {
  IconChevronLeft,
  IconChevronRight,
  IconChevronsLeft,
  IconChevronsRight,
} from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";

import { IconButton } from "../../atoms/IconButton/IconButton";
import { Text } from "../../atoms/Typographies/Text";
import { useTableContext } from "./tableHook";

export const TablePagination = () => {
  const { t } = useTranslation("components");
  const table = useTableContext();

  return (
    <table.Subscribe selector={(state) => state.pagination}>
      {(pagination) => (
        <Group justify="end" gap={spacing[3]} wrap="wrap" py={spacing[3]}>
          <Group gap={spacing[1]}>
            <IconButton
              variant="tertiary"
              size="sm"
              onClick={() => table.firstPage()}
              disabled={!table.getCanPreviousPage()}
              aria-label={t("table.pagination.firstPage")}
            >
              <IconChevronsLeft size={16} />
            </IconButton>
            <IconButton
              variant="tertiary"
              size="sm"
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
              aria-label={t("table.pagination.previousPage")}
            >
              <IconChevronLeft size={16} />
            </IconButton>
            <Text size="small" type="regular" color={colors.text.primaryDefault}>
              {t("table.pagination.pageOf", {
                page: (pagination.pageIndex + 1).toLocaleString(),
                pageCount: table.getPageCount().toLocaleString(),
              })}
            </Text>
            <IconButton
              variant="tertiary"
              size="sm"
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
              aria-label={t("table.pagination.nextPage")}
            >
              <IconChevronRight size={16} />
            </IconButton>
            <IconButton
              variant="tertiary"
              size="sm"
              onClick={() => table.lastPage()}
              disabled={!table.getCanNextPage()}
              aria-label={t("table.pagination.lastPage")}
            >
              <IconChevronsRight size={16} />
            </IconButton>
          </Group>
        </Group>
      )}
    </table.Subscribe>
  );
};
